var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 505,
    height: 157,
    viewBox: "0 0 505 157",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1183",
    "data-name": "Rectangle 1183",
    width: 505,
    height: 157,
    transform: "translate(861 611)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_8",
    "data-name": "Mask Group 8",
    transform: "translate(-861 -611)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(846.28 291.11)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M580.514,322.783a238.262,238.262,0,0,1-366.412,0,52.346,52.346,0,0,0-80.48,66.958,343.347,343.347,0,0,0,527.371,0,52.346,52.346,0,0,0-80.48-66.958Z",
    transform: "translate(-100.633 27.49)",
    fill: "#83b797"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmiles);
export default __webpack_public_path__ + "static/media/smiles.2474880a336b5476a98a79d64e17d654.svg";
export { ForwardRef as ReactComponent };